// Thin facade in front of apps/web/src/auth.ts so that db modules don't
// import auth concerns and so tests can pass their own client without
// touching the singleton.

import type { Db } from "../auth";

/**
 * Returns the user_id for the currently authenticated session.
 * Throws if there is no session — RLS would refuse the write anyway, but
 * we want a clearer error than Supabase's "new row violates row-level
 * security policy".
 */
export async function getUserId(client: Db): Promise<string> {
  const { data, error } = await client.auth.getUser();
  if (error) throw error;
  if (!data.user) throw new Error("Not authenticated");
  return data.user.id;
}

export type { Db };
